<script setup lang="ts">
import { onUnmounted, ref } from 'vue'

import type { AppTip } from '~/server/service/appService'
import type { NuxtResponse } from '~/shared/api/dto'

import EnergyTipp from './EnergyTipp.vue'
import GalleryDots from './GalleryDots.vue'

const currentTipIndex = ref(0)

const { data } = await useFetch<NuxtResponse<AppTip[]>>('/api/cms/tips', {
	key: 'arcgis-content',
})
const intervalId = ref<NodeJS.Timeout | null>(null)

const stopAutoRotate = () => {
	if (intervalId.value) {
		clearInterval(intervalId.value)
		intervalId.value = null
	}
}

onUnmounted(() => {
	stopAutoRotate()
})

const showNextEnergieTipp = () => {
	if (data.value?.data) {
		currentTipIndex.value = (currentTipIndex.value + 1) % data.value.data.length
	}
}
const startAutoRotate = () => {
	intervalId.value = setInterval(showNextEnergieTipp, 7000)
}

onMounted(() => {
	startAutoRotate()
})
</script>

<template>
	<h3 class="bg-land-red px-5 py-2 text-xl font-bold text-white md:text-2xl">
		Energiespar-Tipps
	</h3>

	<div class="relative h-[500px] w-full">
		<div
			v-for="(tip, index) in data?.data || []"
			:key="tip.label"
			class="absolute inset-0 transition-opacity duration-500"
			:class="{
				'opacity-0': index !== currentTipIndex,
				'opacity-100': index === currentTipIndex,
			}"
			@mouseenter="stopAutoRotate"
			@mouseleave="startAutoRotate"
		>
			<div class="relative h-full">
				<CommonAdminEditLink
					v-if="tip.tippId"
					:to="`/admin/cms/tips#${tip.tippId}`"
					:title="`Tipp '${tip.label}' bearbeiten`"
				/>
				<EnergyTipp
					:label="tip.label"
					:text="tip.text"
					:image-src="tip.photo ? `/img/tips/${tip.photo}` : ''"
					@click="showNextEnergieTipp"
				/>
			</div>
		</div>
	</div>

	<div id="displayDotGrid" class="mb-30 mt-8 flex h-3 place-content-center gap-4">
		<GalleryDots
			v-for="(_tip, index) in data?.data || []"
			:key="index"
			:is-active="index === currentTipIndex"
			@click="currentTipIndex = index"
		></GalleryDots>
	</div>
</template>
